import {Injectable, OnDestroy} from '@angular/core'
import {BehaviorSubject, Observable, combineLatest} from 'rxjs'
import {delay, map, first, tap} from 'rxjs/operators'
import {BreakpointObserver} from '@angular/cdk/layout'

@Injectable({
  providedIn: 'root',
})
export class AppAsideService implements OnDestroy {
  asideVisible$ = new BehaviorSubject(false)
  isSmallScreen$: Observable<boolean>
  renderTimeout: number
  constructor(breakpointObserver: BreakpointObserver) {
    this.isSmallScreen$ = breakpointObserver
      .observe(['(max-width: 767.98px)'])
      .pipe(
        map((res) => {
          return res.matches
        }),
      )
  }

  ngOnDestroy(): void {
    if (this.renderTimeout) {
      clearTimeout(this.renderTimeout)
    }
  }

  setVisible(val: boolean) {
    this.asideVisible$.next(val)
  }

  toggleVisible() {
    combineLatest(this.asideVisible$, this.isSmallScreen$)
      .pipe(
        first(),
        tap(([asideVisible, isSmallScreen]) => {
          if (isSmallScreen) {
            // always hide
            document
              .querySelector('body')
              .classList.toggle('aside-menu-hidden', true)
          } else {
            // set to asideVisible and focus on true
            document
              .querySelector('body')
              .classList.toggle('aside-menu-hidden', asideVisible)
            if (!asideVisible) {
              // timeout because the input must be rendered
              this.renderTimeout = window.setTimeout(() => {
                const input: any = document.querySelector('input.domain-filter')
                if (input) {
                  input.focus()
                }
              }, 200)
            }
          }
          // do toggle the behaviorSubject
          this.asideVisible$.next(!asideVisible)
        }),
      )
      .subscribe()
  }

  getVisible() {
    return combineLatest(this.asideVisible$, this.isSmallScreen$).pipe(
      delay(0),
      tap(([asideVisible, isSmallScreen]) => {
        if (isSmallScreen) {
          document
            .querySelector('body')
            .classList.toggle('aside-menu-hidden', true)
        }
      }),
      map(([asideVisible, isSmallScreen]) => {
        if (isSmallScreen) {
          // small screen always false, is replaced by a modal
          return false
        } else {
          return asideVisible
        }
      }),
    )
  }
}
